import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { isMarketingRoute } from "../public-site/siteData";
import { isV2Path } from "../../universal/v2Routes";
import UiFeedbackFab from "./UiFeedbackFab";

export default function UiFeedbackLauncher() {
  const location = useLocation();
  const user = useSelector((state) => state.catalogReducer?.user);
  const isPublicShellRoute = isMarketingRoute(location.pathname);
  const isV2Route = isV2Path(location.pathname);

  if (isPublicShellRoute || !user?.userId || !isV2Route) {
    return null;
  }

  return <UiFeedbackFab user={user} />;
}
